import api from 'api'
import { AccessLevelEnum } from 'enum/accessLevel'

/** Coincidencia en nombre+apellido (columnas visibles) o identificador de ficha. */
export const NAME_AND_LASTNAME_OR_IDENTIFIER_CONT =
  'name_and_lastname_or_identifier_cont' as const

const buildNameOrIdentifierSearchQ = (
  criteria: string
): Record<string, unknown> => {
  const trimmed = criteria.trim()
  if (!trimmed) return {}
  return { [NAME_AND_LASTNAME_OR_IDENTIFIER_CONT]: trimmed }
}

const getAssignedUsers = (
  page: number,
  criteria: string,
  order: string,
  fieldToOrder: string,
  rowsPerPage: number
) => {
  const data = {
    page: page,
    per_page: rowsPerPage,
    q: {
      s: [`${fieldToOrder} ${order}`],
      m: 'and',
      ...buildNameOrIdentifierSearchQ(criteria),
    },
  }
  return api.post('api/v1/roles/assigned_users', data)
}

const removeAllPermissions = (id: number) => {
  return api.delete('api/v1/roles/remove_all_permissions', {
    params: { user_id: id },
  })
}

const removeAllUserPermissions = (userIds: number[]) => {
  return api.delete('api/v1/roles/remove_all_user_permissions', {
    params: { user_ids: userIds },
  })
}

const getUnassignedUsers = (criteria: string) => {
  const q: Record<string, unknown> = {
    s: ['first_name asc'],
    m: 'and',
    ...buildNameOrIdentifierSearchQ(criteria),
  }
  const data = {
    page: 1,
    per_page: 100,
    q,
  }
  return api.post('api/v1/roles/unassigned_users', data)
}

const assignRole = (
  roleId: number,
  userIds: number[],
  accessLevel: AccessLevelEnum,
  profileIds: number[]
) => {
  const data = {
    role_id: roleId,
    user_ids: userIds,
    access_level: accessLevel,
    profile_ids: profileIds,
  }
  return api.post('api/v1/roles/assign_role', data)
}

export const usersService = {
  getAssignedUsers,
  removeAllPermissions,
  removeAllUserPermissions,
  getUnassignedUsers,
  assignRole,
}
